import type { Ref } from 'vue'

/**
 * Composable for updating items in store arrays and current item refs
 * Eliminates duplicate update logic across multiple stores
 */
export function useStoreItemUpdate() {
  /**
   * Updates an item in both the items array and currentItem ref if applicable
   * @param items - Ref to array of items
   * @param currentItem - Ref to current selected item (or null)
   * @param id - ID of item to update
   * @param updatedItem - The updated item data
   */
  const updateItemInStore = <T extends { id: string }>(
    items: Ref<T[]>,
    currentItem: Ref<T | null>,
    id: string,
    updatedItem: T
  ) => {
    // Update in list
    items.value = items.value.map(i => (i.id === id ? updatedItem : i))

    // Update current item if it's the one being updated
    if (currentItem.value && currentItem.value.id === id) {
      currentItem.value = updatedItem
    }
  }

  return {
    updateItemInStore
  }
}
